import { type ReactNode } from "react";

export function renderInlineBold(text: string): ReactNode {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  if (parts.length === 1) return text;
  return parts.map((part, i) =>
    part.startsWith("**") && part.endsWith("**") ? (
      <strong key={i}>{part.slice(2, -2)}</strong>
    ) : (
      part
    ),
  );
}

export function renderInlineMarkdown(text: string): ReactNode {
  const paragraphs = text.split("\n\n");
  if (paragraphs.length === 1) return renderInlineBold(text);
  return paragraphs.map((p, i) => (
    <span key={i} className={i > 0 ? "mt-3 block" : "block"}>
      {renderInlineBold(p)}
    </span>
  ));
}
